import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Steps from "../components/Steps";
import Uruguay from "../components/Uruguay";
import Footer from "../components/Footer";

export default function Landing() {
  const [params] = useSearchParams();
  const highlight = params.get("descargar") === "1";

  useEffect(() => {
    if (highlight) {
      document.getElementById("descargar")?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [highlight]);

  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in-view")),
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="page" data-testid="landing-page">
      <Header />
      <main>
        <Hero highlight={highlight} />
        <Features />
        <Steps />
        <Uruguay />
      </main>
      <Footer />
    </div>
  );
}
